<template>
    <popup :show="true" width="800px" @on-close="onClose">
        <div class="member-alias">
            <div class="alias-pop-title">修改备注名称</div>
            <div class="alias-pop-desc">修改再当前团队备注名,其它团队内的备注名不会被修改</div>
            <div class="alias-input">
                <input type="text" v-model="member_alias" placeholder="请输入备注名称" />
            </div>
            <div class="btn-box">
                <div class="btn" @click="onClose">取消</div>
                <div class="btn" @click="onMemberAliasEdit">确定</div>
            </div>
        </div>
    </popup>
</template>
<script> 
import { teamMemberAlias } from '@/api/index';
import Popup from "@/components/Popup.vue";
export default{
    name:"MemberAlias",
    components:{Popup},
    props:{
        nickName:{
            type:String,
            default:""
        },
        teamId:{
            type:[String,Number],
            default:""
        },
        memberId:{
            type:[String,Number],
            default:''
        }
    },
    data(){
        return{
            member_alias:'',
            team_id:'',
            member_id:''
        }
    },
    mounted(){
        this.member_alias = this.nickName;
        this.member_id = this.memberId;
        this.team_id = this.teamId;
    },
    methods:{
        async onMemberAliasEdit(){
            try{
                const param = {};
                param.uuid = this.team_id;
                param.member_id = this.member_id;
                param.alias = this.member_alias;
                console.log('param-edit-alias',param);
                const {code,msg} = await teamMemberAlias(param);
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('修改成功~');
                this.$emit('on-edit-success');
                this.$emit('on-close');
            }catch(e){
                console.log('err-edit-alias',e);
                this.$layer.msg(e.msg);
            }
        },
        onClose(){
            this.$emit('on-close');
        }
    }
}
</script>
<style lang="scss" scoped>
.member-alias{
    width:100%;
    height:330px;
    background: #fff;
    border-radius: 15px;
    padding:0 50px;
    display:flex;
    flex-direction:column;
    .alias-pop-title{
        color:#1a1a1a;
        font-size:24px;
        font-weight:bold;
        margin-top:60px;
    }
    .alias-pop-desc{
        color:#666;
        font-size:14px;
        margin-top:48px;
    }
    .alias-input{
        width:100%;
        height:60px;
        border-radius:5px;
        border:1px solid #2254f4;
        overflow:hidden;
        margin-top:19px;
        padding:0 11px;
        input{
            width:100%;
            height:100%;
            border:none;
            outline:none;
        }
    }
    .btn-box{
        width:100%;
        margin-top:40px;
        display:flex;
        justify-content:flex-end;
        column-gap:10px;
        .btn{
            width:110px;
            height:32px;
            border-radius:6px;
            background:#ffffff;
            border:1px solid #dedee0;
            line-height:32px;
            text-align:center;
            cursor:pointer;
            color:#4d4d4d;
            font-size:14px;
            &:last-child{
                color:#ffffff;
                background:#ff5967;
                border:none;
            }
        }
    }
}
</style>